import { Node } from '@tiptap/core'

/**
 * This is a modified version of the `Document` Node, which only
 * allows one content block within it. Essentially, this enforces
 * a document with only a single paragraph.
 */
export const SingleLineDocument = Node.create({
  name: 'singleLineDocument',
  topNode: true,
  content: 'block',
})
